// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.footer-selected[data-v-dbd43d7c] { background: #ffb; padding: 5px; border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
